// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","713":"component---src-templates-using-dsg-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"80d7763b63303e835924","713":"709eb97a83db6af4ddda","883":"809cc5ac4c6326673cb1"}[chunkId] + ".js";
};